import React from "react";
import { useEffect } from "react";
import jQuery from "jquery";
import $ from "jquery";
import img1 from "../../assets/img/main-page 1.jpg";
import img2 from "../../assets/img/main-page 2.jpeg";
import img3 from "../../assets/img/main-page 3.jpeg";
import Swiper from "swiper";
import SwiperCore, {
  Navigation,
  Pagination,
  Parallax,
  Autoplay,
  EffectCoverflow,
  Thumbs,
} from "swiper";
import "./FrontPageCarousel.css";
function FrontPageCarousel() {
  // HERO SLIDER

  useEffect(() => {
    SwiperCore.use([
      Navigation,
      Pagination,
      Parallax,
      Autoplay,
      EffectCoverflow,
      Thumbs,
    ]);
    var menu = [];
    jQuery(".swiper-slide").each(function (index) {
      menu.push(jQuery(this).find(".slide-inner").attr("data-text"));
    });
    var interleaveOffset = 0.5;
    var swiperOptions = {
      loop: true,
      speed: 1000,
      observer: true,
      parallax: true,
      autoplay: {
        delay: 6500,
        disableOnInteraction: false,
      },
      watchSlidesProgress: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        // },

        // on: {
        //   progress: function () {
        //     var swiper = this;
        //     for (var i = 0; i < swiper.slides.length; i++) {
        //       var slideProgress = swiper.slides[i].progress;
        //       var innerOffset = swiper.width * interleaveOffset;
        //       var innerTranslate = slideProgress * innerOffset;
        //       swiper.slides[i].querySelector(".slide-inner").style.transform =
        //         "translate3d(" + innerTranslate + "px, 0, 0)";
        //     }
        //   },

        //   touchStart: function () {
        //     var swiper = this;
        //     for (var i = 0; i < swiper.slides.length; i++) {
        //       swiper.slides[i].style.transition = "";
        //     }
        //   },

        //   setTransition: function (speed) {
        //     var swiper = this;
        //     for (var i = 0; i < swiper.slides.length; i++) {
        //       swiper.slides[i].style.transition = speed + "ms";
        //       swiper.slides[i].querySelector(".slide-inner").style.transition =
        //         speed + "ms";
        //     }
        //   },
      },
    };
    var swiper = new Swiper(".swiper-container", swiperOptions);
    var sliderBgSetting = $(".slide-bg-image");
    sliderBgSetting.each(function (indx) {
      if ($(this).attr("data-background")) {
        $(this).css(
          "background-image",
          "url(" + $(this).data("background") + ")"
        );
      }
    });
  }, []);

  return (
    <React.Fragment>
      <section className="hero-slider hero-style">
        <div className="swiper-container">
          <div className="swiper-wrapper">
            <div className="swiper-slide ">
              <div
                className="slide-inner slide-bg-image slide1"
                data-background="https://bindhumadhav.in/alumni/assets/img/main-page%201.jpg"
              >
                <div className="container">
                  <div className="main-post__content">
                    <div
                      className="main-post__tag-wrapper"
                      data-swiper-parallax="300"
                    >
                      <span className="main-post__tag">Alumni Reconnect</span>
                    </div>
                    <h1 className="main-post__title" data-swiper-parallax="400">
                      Recreating wonderful moments with VIT AP.
                    </h1>
                    <div className="clearfix"></div>

                    <a
                      className="main-post__link"
                      href="home.html"
                      data-swiper-parallax="500"
                    >
                      <span className="main-post__link-text">
                        <button className="enter">Know more</button>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="swiper-slide">
              <div
                className="slide-inner slide-bg-image slide2"
                data-background="https://bindhumadhav.in/alumni/assets/img/main-page%202.jpeg"
              >
                <div className="container">
                  <div className="main-post__content">
                    <div
                      className="main-post__tag-wrapper"
                      data-swiper-parallax="300"
                    >
                      <span className="main-post__tag">Alumni Reconnect</span>
                    </div>
                    <h1 className="main-post__title" data-swiper-parallax="400">
                      Recreating wonderful moments with VIT AP.
                    </h1>
                    <div className="clearfix"></div>

                    <a
                      className="main-post__link"
                      href="home.html"
                      data-swiper-parallax="500"
                    >
                      <span className="main-post__link-text">
                        <button className="enter">Know more</button>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="swiper-slide">
              <div
                className="slide-inner slide-bg-image slide3"
                data-background="https://bindhumadhav.in/alumni/assets/img/main-page%203.jpeg"
              >
                <div className="container">
                  <div className="main-post__content">
                    <div
                      className="main-post__tag-wrapper"
                      data-swiper-parallax="300"
                    >
                      <span className="main-post__tag">Alumni Reconnect</span>
                    </div>
                    <h1 className="main-post__title" data-swiper-parallax="400">
                      Recreating wonderful moments with VIT AP.
                    </h1>
                    <div className="clearfix"></div>

                    <a
                      className="main-post__link"
                      href="home.html"
                      data-swiper-parallax="500"
                    >
                      <span className="main-post__link-text">
                        <button className="enter">Know more</button>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="swiper-pagination"></div>
          <div className="swiper-button-next"></div>
          <div className="swiper-button-prev"></div>
        </div>
      </section>
      {/* <div className="carousel page-content_1">
      <header className="main-post-wrapper">
        <div className="slides">
          <article className="main-post main-post--active">
            <div className="main-post__image">
              <img alt="First Image University" src={img1} />
            </div>
            <div className="main-post__content">
              <div className="main-post__tag-wrapper">
                <span className="main-post__tag">Alumni Reconnect</span>
              </div>
              <h1 className="main-post__title">
                Recreating wonderful moments with VIT AP.
              </h1>
              <a className="main-post__link" href="home.html">
                <span className="main-post__link-text">
                  <button className="enter">Know more</button>
                </span>
              </a>
            </div>
          </article>
          <article className="main-post main-post--not-active">
            <div className="main-post__image">
              <img alt="Second image University" src={img2} />
            </div>
            <div className="main-post__content">
              <div className="main-post__tag-wrapper">
                <span className="main-post__tag">Alumni Recreate</span>
              </div>
              <h1 className="main-post__title">
                VIT focuses on providing global experience to it's students.
              </h1>
              <a className="main-post__link" href="home.html">
                <span className="main-post__link-text">
                  <button className="enter">Welcome</button>
                </span>
              </a>
            </div>
          </article>
          <article className="main-post main-post--not-active">
            <div className="main-post__image">
              <img alt="Thrid image University" src={img3} />
            </div>
            <div className="main-post__content">
              <div className="main-post__tag-wrapper">
                <span className="main-post__tag">Alumni Represent</span>
              </div>
              <h1 className="main-post__title">
                VIT is now ranked No 1 Private University in India.
              </h1>
              <a className="main-post__link" href="home.html">
                <span className="main-post__link-text">
                  <button className="enter">Get started</button>
                </span>
              </a>
            </div>
          </article>
        </div>
      </header>
    </div> */}
    </React.Fragment>
  );
}
export default FrontPageCarousel;
